import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ethers } from 'ethers';

export const connectProvider = createAsyncThunk(
  'provider/connectProvider',
  async (_, { rejectWithValue }) => {
    try {
      if (!window.ethereum) {
        return rejectWithValue('MetaMask is not installed.');
      }
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      await provider.send('eth_requestAccounts', []);
      const signer = provider.getSigner();
      const account = await signer.getAddress();
      const network = await provider.getNetwork();
      return { provider, account, chainId: network.chainId };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to connect wallet');
    }
  }
);

const providerSlice = createSlice({
  name: 'provider',
  initialState: {
    connection: null,
    chainId: null,
    account: '',
    loading: false,
    error: null,
  },
  reducers: {
    setConnection(state, action) {
      state.connection = action.payload;
    },
    setAccount(state, action) {
      state.account = action.payload || '';
    },
    setNetwork(state, action) {
      state.chainId = action.payload;
    },
    setProviderState(state, action) {
      const { connection, account, chainId } = action.payload || {};
      if (connection !== undefined) state.connection = connection;
      if (account !== undefined) state.account = account;
      if (chainId !== undefined) state.chainId = chainId;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(connectProvider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(connectProvider.fulfilled, (state, action) => {
        state.loading = false;
        state.connection = action.payload.provider;
        state.account = action.payload.account;
        state.chainId = action.payload.chainId;
      })
      .addCase(connectProvider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setConnection,
  setAccount,
  setNetwork,
  setProviderState,
  setError,
  clearError,
} = providerSlice.actions;

export default providerSlice.reducer;
